// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"113":"tgBrightcove","294":"tgGallery"}[chunkId] + "." + {"113":"68eca3d27f199b65bea9","294":"5172b4ec4480d42e5a30"}[chunkId] + ".min.js";
};